<kor-modal
  [visible]="visible"
  width="400px"
  height="auto"
  (visible-changed)="!$event.target.visible ? close.emit() : ''"
>
  <!-- sign in -->
  <ng-container *ngIf="!registerVisible; else register">
    <app-sign-in
      (signIn)="close.emit()"
      (register)="registerVisible = true"
    ></app-sign-in>
  </ng-container>
  <!-- register -->
  <ng-template #register>
    <app-register
      (register)="close.emit()"
      (return)="registerVisible = false"
    ></app-register>
  </ng-template>
</kor-modal>
